import gql from 'graphql-tag';

import type EntityContext from 'common/constants/entityContexts';
import type Permissions from 'common/constants/permissions';

export const PermissionsFragment = gql`
  fragment PermissionsFragment on PermissionScope {
    entityId
    context
    permissions {
      permissionName
      hasAccess
    }
  }
`;

type UUID = string;

export type PermissionInfo = {
  permissionName: Permissions;
  hasAccess: boolean;
};

export type PermissionsFragmentResponse = {
  entityId?: UUID | null;
  context?: EntityContext | null;
  permissions: PermissionInfo[];
};
